/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Lot_Debt_Fill_AppliedInputs */

const vi_lot_debt_fill_applied = /** @type {(inputs: Lot_Debt_Fill_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bù cho đơn: ${i?.qty} ${i?.unit}`)
};

/**

* @param {Lot_Debt_Fill_AppliedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_applied = /** @type {((inputs: Lot_Debt_Fill_AppliedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_AppliedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_applied(inputs)
});